import React, { useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { getRelativeUrl } from '@utils'
import winPixel from '@utils/winPixel'

export const useProducts = (isMobild?: boolean, props?: any) => {
  const { params, pageType, onFetch, onChangePage } = props
  // store数据
  const productsData = useSelector((state: any) => state.products, shallowEqual)
  const {
    categoryName,
    categoriesImg,
    categoriesDescription,
    productList,
    pageSize,
    productCount,
    page,
    navBread,
    maxPrice,
    metaInfo,
    mCategoriesImg
  } = productsData?.data || {}
  const filterData = productsData?.filter || {}

  // 面包屑
  const [breadcrumbItems, setBreadcrumbItems] = useState([])
  useEffect(() => {
    let arr: any = []
    if (navBread?.length) {
      navBread.forEach((nav: any) => {
        arr.push({ title: nav.title, href: getRelativeUrl(nav.href) })
      })
    }
    setBreadcrumbItems(arr)
    // if (isSearch && params.keywords) {
    //   winPixel.search(params.keywords, productList.length)
    // }
  }, [navBread])

  useEffect(() => {
    if (productsData) {
      const productSkuIds = productsData?.data?.productList?.map((item) => {
        return item.productsSkuId
      })
      // console.log('productSkuIds: ', productSkuIds)
      winPixel.pLoad.category(productSkuIds, productsData?.data?.categoryName)
    }
  }, [productsData])

  const [pageName, setPageName] = useState('')
  const [isFlashDeal, setIsFlashDeal] = useState(false)
  useEffect(() => {
    setIsFlashDeal(!!(pageType === 1))
    switch (pageType) {
      case 1:
        setPageName('Flash Sale')
        break
      case 2:
        setPageName('Best Sellers')
        break
      case 3:
        setPageName('New Arrivals')
        break
      default:
        setPageName('')
        break
    }
  }, [pageType])
  const [sortLabel, setSortLabel] = useState('Recommended')

  // 属性更新
  const changeAttrSelect = (obj: any) => {
    let newObj: any = { ...obj }
    if (!isMobild) {
      newObj.page = 1
    }
    onFetch && onFetch({ ...newObj })
  }

  // 排序更新
  const handleChangeSort = (value?: string, label?: string) => {
    let newValue = value
    if (value === 'price') {
      if (params.order === '2') {
        newValue = '3' // 降序
      } else {
        newValue = '2' // 升序
      }
    }
    let newObj: any = { order: newValue }
    if (!isMobild) {
      newObj.page = 1
    }
    // isMobild && setSortLabel(label)
    onFetch && onFetch({ ...newObj })
  }

  const changePage = (page: number) => {
    onChangePage(page)
  }

  const [size, useSize] = React.useState(props.pageSize)

  const changePages = () => {
    const next = size + props.pageSize
    onChangePage(1, next)
    useSize(next)
  }

  // attr选择属性改变时触发
  const [display, setDisplay] = useState([])
  // useEffect(() => {
  //   if (!filterData?.filterList.length) return
  //   const data = JSON.parse(JSON.stringify(params))
  //   const filters = data.filterValueIds ? data.filterValueIds.split(',') : []
  //   if (filters.length) {
  //     const arrs: any = filterData.filterList
  //       .flatMap((k: any) => k.productsOptionValuesList)
  //       .filter((item: any) => filters.includes(item.productsOptionsValuesId))
  //     setDisplay(arrs)
  //   } else {
  //     setDisplay([])
  //   }
  // }, [params.filterValueIds, filterData.filterList])

  useEffect(() => {
    if (!filterData?.filterList?.length) return
    const { filterValueIds, filterCat } = params
    const filtersValues = filterValueIds ? filterValueIds.split(',') : []
    const filterCats = filterCat ? filterCat.split(',') : []
    const filters = [...filtersValues, ...filterCats]
    if (filters.length) {
      let arrs = []
      // 判断类目是's', 还是'c'，两者结构不同
      const isScate =
        filterData.filterList?.find((i) => i.productsOptionsId === 's') || {}
      if (isScate.productsOptionsId === 's') {
        const newArr =
          filterData.filterList
            ?.find((i) => i.productsOptionsId === 's')
            ?.productsOptionValuesList?.flatMap((c) => c.children)
            ?.filter((item) => filters.includes(item?.id + ''))
            .map((item) => {
              return {
                ...item,
                productsOptionsId: 's'
              }
            }) || []
        const norArr =
          filterData.filterList
            ?.filter((i) => i.productsOptionsId !== 's')
            ?.flatMap((k) => k.productsOptionValuesList)
            ?.filter((item) =>
              filters.includes(item?.productsOptionsValuesId + '')
            ) || []
        arrs = [...newArr, ...norArr]
      } else {
        arrs = filterData.filterList
          ?.flatMap((k) => k.productsOptionValuesList)
          ?.filter((item) =>
            filters.includes(item?.productsOptionsValuesId + '')
          )
      }
      setDisplay(arrs || [])
    } else {
      setDisplay([])
    }
  }, [params.filterValueIds, params.filterCat, filterData.filterList])

  // 删除某个选中
  const removeActive = (
    v: string | number,
    paramKey?: string,
    isOther?: boolean
  ) => {
    React.startTransition(() => {
      const data = JSON.parse(JSON.stringify(params))
      const value = String(v)
      let obj: any = {}
      if (isOther) {
        obj[`min${paramKey}`] = undefined
        obj[`max${paramKey}`] = undefined
      } else {
        let ids = data[paramKey]?.split(',') || []
        if (ids.indexOf(value) === -1) {
          ids.push(value)
        } else {
          ids.splice(ids.indexOf(value), 1)
        }
        obj[paramKey] = ids.filter((el: string) => el !== '').join(',')
      }
      let newObj: any = { ...obj }
      if (!isMobild) {
        newObj.page = 1
      }
      onFetch && onFetch(newObj)
    })
  }

  const removeAll = () => {
    const obj = {
      filterCat: undefined,
      filterValueIds: undefined,
      minPrice: '',
      maxPrice: ''
    }
    let newObj: any = { ...obj }
    if (!isMobild) {
      newObj.page = 1
    }

    onFetch && onFetch(newObj)
  }

  useEffect(() => {
    let str = ''
    switch (params.order) {
      case '1':
        str = 'Recommended'
        break
      case '2':
        str = 'Price High - Low'
        break
      case '3':
        str = 'Price Low - High'
        break
      case '4':
        str = 'New Arrival'
        break
      case '5':
        str = 'Customer Rating'
        break
    }
    setSortLabel(str)
  }, [params.order])

  return {
    size,
    changePages,
    metaInfo,
    navBread,
    breadcrumbItems,
    pageName,
    productList,
    isFlashDeal,
    categoriesImg,
    mCategoriesImg,
    categoryName,
    categoriesDescription,
    filterData,
    pageSize,
    productCount,
    changeAttrSelect,
    productsData,
    display,
    removeActive,
    maxPrice,
    removeAll,
    handleChangeSort,
    page,
    changePage,
    sortLabel,
    banners: productsData?.banners
  }
}
